import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicPageLayout from '../../components/layout/PublicPageLayout';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import ComplianceBar from '../../components/ComplianceBar';

// IMPORTED
const { FiBriefcase, FiUserCheck, FiShield, FiArrowRight } = FiIcons;

const EksternVarslingPage = () => {
    const navigate = useNavigate();

  return (
    <PublicPageLayout 
      title="Ekstern og uavhengig varsling" 
      subtitle="Når habilitet er et tema, gir ekstern håndtering trygghet for alle parter."
      activePage="/ekstern-varsling"
    >
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12 mb-16">
        {/* Intro */}
        <section className="prose prose-lg prose-slate max-w-none">
          <p className="text-xl leading-relaxed text-slate-600 font-medium">
            I mange tilfeller kan det være vanskelig å håndtere et varsel internt. Dette gjelder spesielt hvis varselet retter seg mot toppledelsen, HR-ansvarlig, eller hvis det er sterke interessekonflikter i organisasjonen. Da er en ekstern varslingskanal løsningen.
          </p>
        </section>

        {/* Main Content - Mode 2: Reflective */}
        <section className="space-y-8">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 mb-4">
                <SafeIcon icon={FiUserCheck} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Habilitet og tillit</h3>
              <p className="text-slate-600">
                Ved å bruke en ekstern part (som advokat eller revisor) til å motta og vurdere varsler, fjerner man mistanken om at "bukken passer havresekken". Dette øker sannsynligheten for at ansatte tør å si ifra.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center text-green-600 mb-4">
                <SafeIcon icon={FiBriefcase} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Profesjonell håndtering</h3>
              <p className="text-slate-600">
                Varslingssaker krever juridisk kompetanse og erfaring med faktaundersøkelser. En ekstern utreder sikrer at saken behandles korrekt i henhold til arbeidsmiljøloven og personvernreglene.
              </p>
            </div>
          </div>
        </section>

        {/* When to use */}
        <section className="bg-slate-50 rounded-2xl p-8 border border-slate-100">
          <h2 className="text-2xl font-bold text-slate-900 mb-6">Når bør man velge ekstern håndtering?</h2>
          <ul className="space-y-4">
            {[
              "Når varselet gjelder øverste leder eller styret",
              "I små bedrifter hvor 'alle kjenner alle'",
              "Når bedriften mangler intern kompetanse på saksbehandling",
              "Ved alvorlige anklager om korrupsjon eller lovbrudd",
              "Når det er lav tillit mellom ansatte og ledelse"
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <div className="mt-1.5 w-2 h-2 bg-indigo-500 rounded-full flex-shrink-0"></div>
                <span className="text-slate-700 font-medium">{item}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* How we solve it */}
        <section className="text-center bg-indigo-900 text-white rounded-2xl p-10 shadow-xl">
          <SafeIcon icon={FiShield} className="text-4xl text-indigo-300 mx-auto mb-6" />
          <h2 className="text-3xl font-bold mb-4">Vi tilbyr ekstern mottaksfunksjon</h2>
          <p className="text-indigo-100 max-w-xl mx-auto mb-8 text-lg">
            HMS Varsling kan fungere som deres eksterne varslingsmottak. Vi mottar, vurderer og kategoriserer varselet før det sendes til riktig instans i din bedrift – eller behandles videre av våre utredere.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* FIXED NAV LINKS */}
            <button onClick={() => navigate('/priser-utredning')} className="bg-white text-indigo-900 px-6 py-3 rounded-xl font-bold hover:bg-indigo-50 transition-colors">
              Se priser for utredning
            </button>
            <button onClick={() => navigate('/company/register')} className="border border-indigo-300 text-indigo-100 px-6 py-3 rounded-xl font-bold hover:bg-indigo-800 transition-colors">
              Registrer bedrift
            </button>
          </div>
        </section>
      </article>

      {/* --- ADDED COMPLIANCE BAR --- */}
      <ComplianceBar />
    </PublicPageLayout>
  );
};

export default EksternVarslingPage;